import { render, staticRenderFns } from "./NewNotificaciones.vue?vue&type=template&id=6530e04a&"
import script from "./NewNotificaciones.vue?vue&type=script&lang=ts&"
export * from "./NewNotificaciones.vue?vue&type=script&lang=ts&"
import style0 from "./NewNotificaciones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports